<template>
    <Schema v-if="schemaText" :text="schemaText" />
</template>

<script>
import { mapGetters } from 'vuex';
import Schema from './json-schema.vue';
import { buildAggregateOfferSchema } from '@/common/utilities/aggregate-offer-schema.js';

export default {
    name: 'AggregateOfferSchema',
    components: { Schema },
    computed: {
        ...mapGetters('msp', ['geo', 'getCurrentPageListings', 'getSearchType']),
        ...mapGetters('glb', ['glb', 'getSeoInfo']),
        schemaText() {
            const schema = buildAggregateOfferSchema({
                geo: this.geo,
                searchType: this.getSearchType,
                currentPageListings: this.getCurrentPageListings,
                vanillaCase: this.getSeoInfo?.vanillaCase,
                rentals: this.glb.rentals,
                isSold: (this.glb.requestUrlRaw || '').includes('sold/'),
            });
            return schema ? JSON.stringify(schema) : null;
        },
    },
};
</script>
